import { TypeByAttribute, TypeByBooleanAttribute } from '../../../factories/ContextQuery/QueryParamSelectors';
import { TypeByBattery } from '../../../factories/ContextQuery/QueryParamSelectors/typeByBattery';
import { TypeByCount } from '../../../factories/ContextQuery/QueryParamSelectors/typeByCount';
import { TypeByCustomer } from '../../../factories/ContextQuery/QueryParamSelectors/typeByCustomer';
import { TypeByDeviceType } from '../../../factories/ContextQuery/QueryParamSelectors/typeByDeviceType';
import { TypeByError } from '../../../factories/ContextQuery/QueryParamSelectors/typeByError';
import { TypeByNetwork } from '../../../factories/ContextQuery/QueryParamSelectors/typeByNetwork';
import { TypeByParent } from '../../../factories/ContextQuery/QueryParamSelectors/typeByParent';
import { TypeByProperty } from '../../../factories/ContextQuery/QueryParamSelectors/typeByProperty';
import { TypeBySeen } from '../../../factories/ContextQuery/QueryParamSelectors/typeBySeen';
import { TypeBySignal } from '../../../factories/ContextQuery/QueryParamSelectors/typeBySignal';
import { TypeByState } from '../../../factories/ContextQuery/QueryParamSelectors/typeByState';
export const componentParamPairsMap = {
    EUIHas: {
        ParamSelector: TypeByAttribute,
        ParamSelectorProps: { type: 'Device', attKey: 'eui' },
    },
    DevType: {
        ParamSelector: TypeByDeviceType,
        ParamSelectorProps: { type: 'Device', attKey: 'deviceType' },
    },
    State: {
        ParamSelector: TypeByState,
        ParamSelectorProps: { type: 'Device', attKey: 'state' },
    },
    Battery: {
        ParamSelector: TypeByBattery,
        ParamSelectorProps: { type: 'Device', attKey: 'batteryLevel' },
    },
    Signal: {
        ParamSelector: TypeBySignal,
        ParamSelectorProps: { type: 'Device' },
    },
    FrameCount: {
        ParamSelector: TypeByCount,
        ParamSelectorProps: { type: 'Device', attKey: 'yesterdaysFCntJumpTotal' },
    },
    MessageCount: {
        ParamSelector: TypeByCount,
        ParamSelectorProps: { type: 'Device', attKey: 'yesterdaysMessageCntTotal' },
    },
    LastSeen: {
        ParamSelector: TypeBySeen,
        ParamSelectorProps: { type: 'Device', attKey: 'lastSeen' }, //lastSendPeriod
    },
    Network: {
        ParamSelector: TypeByNetwork,
        ParamSelectorProps: { type: 'Device', attKey: 'networkKey' },
    },
    AWOL: {
        ParamSelector: TypeByBooleanAttribute,
        ParamSelectorProps: { type: 'Device', attKey: 'isAWOL' },
    },
    Gateway: {
        ParamSelector: TypeByParent,
        ParamSelectorProps: { type: 'Device', attKey: 'Gateway', supportKey: 'lastGatewayEui' },
    },
    Error: {
        ParamSelector: TypeByError,
        ParamSelectorProps: { type: 'Device', attKey: 'error' },
    },
    // unique paths
    Customer: {
        ParamSelector: TypeByCustomer,
        ParamSelectorProps: { type: 'Device', attKey: 'Customer', unique: true },
    },
    Property: {
        ParamSelector: TypeByProperty,
        ParamSelectorProps: { type: 'Device', attKey: 'Property', unique: true },
    },
};
